import { useEffect } from "react";
import ReactGA from "react-ga";


const useGaTracker = (pageLabel) => {
	
	const googleAnalyticsTrackingId = process.env.REACT_APP_GA;
	ReactGA.initialize(googleAnalyticsTrackingId);

	useEffect(() => {
		ReactGA.pageview(pageLabel);
	}, []);
};

export default useGaTracker;

